import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { validateSurface, badgeBackgroundColors } from '../../globals.js';
import styles from './badge-indicator.module.scss.js';
import calculateRem from '../../utilities/calculate-rem/index.js';
import 'react';
import '../../_virtual/_tslib.js';
import useLimitDigits from '../../utilities/use-limit-digits/index.js';
import '../../utilities/use-viewport/index.js';

/**
 * @component BadgeIndicator
 * @package Badges
 * @document ../_docs/code/BadgeIndicator.editor.tsx
 * @document ../_docs/code/BadgeIndicator.snippet.tsx
 * @document ../_docs/code/BadgeIndicator.import.tsx
 */
const BadgeIndicator = ({ surface: surfaceProp = 'lightPrimary', kind = 'simple', backgroundColor = 'red', leadingCharacter, trailingText, children, size = 'small', showBorder = true, showDot = true, id, maximumDigits = 2, ariaHidden, containerSize = '16px', // set default size of the container
textColor, padding, borderColor, decimalPoints = 0, dotSize = '6px', }) => {
    const _limitDigits = useLimitDigits({
        value: children === undefined || children === '' ? '0' : children,
        decimalPoints,
        maximumDigits,
    });
    // Normalize the surface prop
    const surface = validateSurface(surfaceProp);
    const badgeIndicatorStyles = [
        styles.badgeIndicator,
        styles[backgroundColor.toLocaleLowerCase()],
        styles[surface.toLocaleLowerCase()],
        styles[kind],
        styles[size === '2xlarge' ? 'twoxlarge' : size.toLocaleLowerCase()],
    ];
    // initialize variables
    if (!showBorder)
        badgeIndicatorStyles.push(styles.hideBorder);
    const getContainerStyles = () => {
        let _backgroundColor = backgroundColor;
        if (backgroundColor && badgeBackgroundColors.includes(backgroundColor)) {
            _backgroundColor = undefined;
        }
        return {
            backgroundColor: _backgroundColor,
            color: textColor || undefined,
            boxShadow: (borderColor && showBorder && `0 0 0 1px ${borderColor}`) || undefined,
            height: kind === 'simple' ? calculateRem(containerSize || 16) : undefined,
            minWidth: kind === 'simple' ? calculateRem(containerSize || 16) : undefined,
        };
    };
    const _renderIndicator = () => {
        if (kind === 'simple') {
            if (!showDot)
                return null;
            return (jsx("div", { "aria-hidden": ariaHidden, className: styles.simpleContainer, children: jsx("div", { style: {
                        height: dotSize || undefined,
                        width: dotSize || undefined,
                        backgroundColor: textColor || undefined,
                    }, className: styles.simple }) }));
        }
        return (jsx("div", { className: styles.numberedContainer, "aria-hidden": ariaHidden, style: {
                padding,
            }, children: jsxs("div", { className: styles.numbered, "aria-hidden": ariaHidden, children: [leadingCharacter && jsx("span", { children: leadingCharacter }), jsx("span", { children: _limitDigits }), trailingText && trailingText.trim() && (jsxs("span", { children: ["\u00A0", trailingText.trim()] }))] }) }));
    };
    return (jsx("div", { className: badgeIndicatorStyles.join(' '), id: id, "aria-hidden": ariaHidden, style: getContainerStyles(), children: _renderIndicator() }));
};

export { BadgeIndicator, BadgeIndicator as default };
